import React from 'react';
import PropTypes from 'prop-types';

import Select from 'react-select';

import { mapId, mapName } from 'helpers/react_select_helpers';

import './styles.scss';

export function ShadowCreationModalBody({ grid, grids, onGridChange }) {
  return (
    <React.Fragment>
      <label>Select Grid Template</label>
      <Select
        getOptionLabel={mapName}
        getOptionValue={mapId}
        options={grids}
        value={grid}
        onChange={onGridChange}
      />
    </React.Fragment>
  );
}

ShadowCreationModalBody.propTypes = {
  grid: PropTypes.object,
  grids: PropTypes.array.isRequired,
  onGridChange: PropTypes.func.isRequired,
};

export default ShadowCreationModalBody;
